import UploadPage from './UploadPage';

export default UploadPage;
